import { baseUrl } from "util/APIBaseUrl";
import { applyPlgFeatures } from "plg/features";

const STATUS_TIMEOUT_MS = 5000;

let enabled = false;

/**
 * PRD-3334 kill switch: the backend's PLG_AUTH_CONFIG.enabled, read from GET /v1/plg/status, which also
 * carries the PLG feature switches (Platform_Config PLG_FEATURES). Called once before the app renders.
 * Anything but a successful `enabled: true` keeps PLG off.
 */
export async function loadPlgSelfServe(): Promise<void> {
  try {
    const res = await fetch(`${baseUrl}/v1/plg/status`, { signal: AbortSignal.timeout(STATUS_TIMEOUT_MS) });
    const body = res.ok ? await res.json() : null;
    enabled = body?.enabled === true;
    applyPlgFeatures(body?.features);
  } catch {
    enabled = false;
  }
}

export default function usePlgSelfServe(): boolean {
  return enabled;
}
